// extracted by mini-css-extract-plugin
module.exports = {"Buoy":"styles_Buoy__zIm-T","leaflet-popup-content-wrapper":"styles_leaflet-popup-content-wrapper__1sDWC"};